import React, { useState, useEffect } from 'react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
const EditSubCategory = ({  onSuccess }) => {
  const [name, setName] = useState('');
  const [duration, setDuration] = useState('');
  const [price, setPrice] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const location = useLocation();
    const subcategory = location.state?.data;
  const navigate = useNavigate();

  useEffect(() => {
    console.log(subcategory)
    fetchCategories();
    if (subcategory) {
      setName(subcategory.name || '');
      setDuration(subcategory.service_duration || '');
      setPrice(subcategory.price || '');
      setCategoryId(subcategory.category_id || '');
    }
  }, [subcategory]);

  const fetchCategories = async () => {
    try {
      const response = await DataService.getCategories();
      setCategories(response.data);
    } catch (error) {
      setError('Failed to fetch categories');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  console.log("Form submitted");

    if (!name || !duration || !price || !categoryId) {
      setError('All fields are required.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const payload = {
        id: subcategory.id,
        name,
        service_duration: Number(duration),
        price:Number(price),
        category_id: categoryId
      };
      await DataService.updateSubCategory(payload);
        navigate('/sub-categories')
        
        toast.success('Sub category updated successfully.')
    } catch (err) {
      setError('Failed to update subcategory.');
    } finally {
      setLoading(false);
    }
  };

  if (!subcategory) {
    return <div className="container mt-4">No subcategory selected for editing.</div>;
  }
const goBack = () => navigate(-1); // navigate back to previous page

  return (
    <div>
      <LoaderOverlay loading={loading} />
      <h4>Edit Subcategory</h4>

      <form onSubmit={handleSubmit} className="mt-3">
        <div className="mb-3">
          <label className="form-label">Subcategory Name</label>
          <input
            type="text"
            className="form-control  px-3"
            placeholder="Enter subcategory name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Select Category</label>
          <select
              className="form-control form-select custom-select-style"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Service Duration (in minutes)</label>
          <input
            type="number"
            className="form-control  px-3"
            placeholder="e.g. 30"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Price</label>
          <input
            type="number"
            className="form-control  px-3"
            placeholder="Enter price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary">
          Update Subcategory
        </button>
        <button type="button" className="btn btn-outline-secondary" style={{marginLeft:'15px'}} onClick={goBack}>
    ← Back
  </button>
      </form>
    </div>
  );
};

export default EditSubCategory;
